import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RetentionSettingsValues } from 'pages/MediaCluster/types';
import { MediaNodes } from '../types';

type InitialState = {
  isLoading: boolean;
  nodes: MediaNodes | null;
  error: any;
  setLoading: boolean;
  setErrors: any;
  settings: any;
  settingsError: any;
  settingsLoading: boolean;
};

const initialState: InitialState = {
  isLoading: false,
  nodes: null,
  error: null,
  setLoading: false,
  setErrors: null,
  settings: null,
  settingsError: null,
  settingsLoading: false,
};

const mediaCluster = createSlice({
  name: 'mediaCluster',
  initialState,
  reducers: {
    requestNodes: (state) => {
      state.isLoading = true;
    },
    getNodesSuccess: (state, { payload }: PayloadAction<MediaNodes>): void => {
      state.isLoading = false;
      state.nodes = payload;
    },
    getNodesError: (state, { payload }: PayloadAction<string>): void => {
      state.isLoading = false;
      state.error = payload;
    },
    clearNodes: (state): void => {
      state.nodes = null;
    },
    requestSetModulClaster: (state, { payload }: PayloadAction<RetentionSettingsValues>) => {
      state.setLoading = true;
    },
    setModulClasterSuccess: (state) => {
      state.setLoading = false;
    },
    setModulClasterError: (state, { payload }: PayloadAction<string>) => {
      state.setLoading = false;
      state.setErrors = payload;
    },
    requestMediaClusterSettings: (state) => {
      state.settingsLoading = true;
    },
    getMediaClusterSettingsSuccess: (state, { payload }: PayloadAction<any>) => {
      state.settingsLoading = false;
      state.settings = payload;
    },
    getMediaClusterSettingsError: (state, { payload }: PayloadAction<any>) => {
      state.settingsLoading = false;
      state.settingsError = payload;
    },
  },
});

export const {
  requestNodes,
  getNodesSuccess,
  getNodesError,
  clearNodes,
  setModulClasterError,
  setModulClasterSuccess,
  requestSetModulClaster,
  requestMediaClusterSettings,
  getMediaClusterSettingsSuccess,
  getMediaClusterSettingsError,
} = mediaCluster.actions;

export default mediaCluster.reducer;
